import React from "react";
import { Route, Link, Redirect } from "react-router-dom";
import { Breadcrumbs, BreadcrumbsItem } from "@sainsburys-tech/fable";
import PageTitle from "../PageTitle";
import StoreCommissioningStepper from "./StoreCommissioningStepper";

import StoreZonesPage from "../StoreZonesPage/StoreZonesPage";
import StoreTestScenesPage from "../StoreTestScenesPage/StoreTestScenesPage";
import StoreZonesReviewPage from "../StoreZonesReviewPage/StoreZonesReviewPage";
import areZonesConfiguredForStore from "../../model/store-commissioning/areZonesConfiguredForStore";

const StoreCommissioningRoutes = props => (
  <React.Fragment>
    <Route
      path="/lighting/stores/:storeId/commissioning/zones"
      render={() => {
        return (
          <StoreZonesPage
            store={props.store}
            scenes={props.scenes}
            onZoneDelete={props.onZoneDelete}
          />
        );
      }}
    />
    <Route
      path="/lighting/stores/:storeId/commissioning/test-scenes"
      render={() => {
        const res = areZonesConfiguredForStore(props.store);
        if (!res)
          return (
            <Redirect
              to={`/lighting/stores/${props.store.store.storeId}/commissioning/zones`}
            />
          );
        return (
          <StoreTestScenesPage
            scenes={props.scenes}
            store={props.store}
            onLightingStoresChange={props.onLightingStoresChange}
          />
        );
      }}
    />
    <Route
      path="/lighting/stores/:storeId/commissioning/review"
      render={() => {
        const res = areZonesConfiguredForStore(props.store);
        if (!res)
          return (
            <Redirect
              to={`/lighting/stores/${props.store.store.storeId}/commissioning/zones`}
            />
          );
        return (
          <StoreZonesReviewPage
            store={props.store}
            completeCommissioning={props.completeCommissioning}
            onLightingStoresChange={props.onLightingStoresChange}
          />
        );
      }}
    />
  </React.Fragment>
);

const StoreCommissioningPage = props => {
  const mapStore = store => {
    return {
      storeId: store.store.storeId,
      name: store.store.name
    };
  };

  const store = mapStore(props.store);
  const steps = [
    {
      name: "Create zones and scenes",
      url: `/lighting/stores/${store.storeId}/commissioning/zones`,
      isCompleted: true,
      isDisabled: false
    },
    {
      name: "Test scenes",
      url: `/lighting/stores/${store.storeId}/commissioning/test-scenes`,
      isCompleted: true,
      isDisabled: !areZonesConfiguredForStore(props.store)
    },
    {
      name: "Review",
      url: `/lighting/stores/${store.storeId}/commissioning/review`,
      isCompleted: false,
      isDisabled: !areZonesConfiguredForStore(props.store)
    }
  ];
  const currentStep = steps.find(step => step.url === props.pathName);
  return (
    <PageTitle title="Commissioning">
      <React.Fragment>
        <Breadcrumbs shouldShowCurrentPage={true}>
          <BreadcrumbsItem href="/stores/">
            Stores
          </BreadcrumbsItem>
          <BreadcrumbsItem href={`/stores/${store.storeId}`}>
            {store.name}
          </BreadcrumbsItem>
          <BreadcrumbsItem href={currentStep.url}>
            Commissioning
          </BreadcrumbsItem>
        </Breadcrumbs>

        <div className="fable:mb-2">
          <StoreCommissioningStepper
            steps={steps}
            currentStep={steps.indexOf(currentStep)}
          />
        </div>
        <StoreCommissioningRoutes {...props} />
      </React.Fragment>
    </PageTitle>
  );
};

export default StoreCommissioningPage;
